import { z } from "zod";

export const experienceFormSchema = z.object({
    bio: z.string().optional(),
})

export type ExperienceFormSchema = z.infer<typeof experienceFormSchema>;
